import { render, staticRenderFns } from "./CategoriesContainerView.vue?vue&type=template&id=e5fb8698&"
import script from "./CategoriesContainerView.vue?vue&type=script&lang=js&"
export * from "./CategoriesContainerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports